const initialState = {
    anchor: 'left',
    tanque: [],
    open: false,
    id: '',
    id_fazenda: '',
    periodo: '',
    volume: '',
    vacas_lactacao: '',
    media_litros_leite_dia: '',
    ccs: '',
    ufc: '',
    gordura: '',
    proteina: '',
    nul: '',
    preco_litro: '',
    faturamento: '',
    arquivo: null,
    data_cadastro: '',
    usuario_cadastro: '',
    data_exclusao: '',
    usuario_exclusao: '',
};

export function tanque(state = initialState, action) {
    switch (action.type) {
        case 'FETECHED_ALL_TANQUE':
            return {
                ...state,
                tanque: action.tanque
            };
        case 'TANQUE_DETAIL':
            return {
                ...state,
                id: action.id,
                id_fazenda: action.id_fazenda,
                periodo: action.periodo,
                volume: action.volume,
                vacas_lactacao: action.vacas_lactacao,
                media_litros_dia: action.media_litros_dia,
                ccs: action.ccs,
                ufc: action.ufc,
                gordura: action.gordura,
                proteina: action.proteina,
                nul: action.nul,
                preco_litro: action.preco_litro,
                faturamento: action.faturamento,
                data_cadastro: action.data_cadastro,
                usuario_cadastro: action.usuario_cadastro,
                data_exclusao: action.data_exclusao,
                usuario_exclusao: action.usuario_exclusao,
            };
        case "TANQUE_UPDATED":
            return state;
        case "HANDLE_ON_CHANGE":
            return {
                ...state,
                [action.props]: action.value
            };
        case 'TANQUE_CLEAR':
            return {
                ...state,
                anchor: 'left',
                tanque: [],
                open: false,
                id: '',
                id_fazenda: '',
                periodo: '',
                volume: '',
                vacas_lactacao: '',
                media_litros_leite_dia: '',
                ccs: '',
                ufc: '',
                gordura: '',
                proteina: '',
                nul: '',
                preco_litro: '',
                faturamento: '',
                arquivo: null,
                data_cadastro: '',
                usuario_cadastro: '',
                data_exclusao: '',
                usuario_exclusao: '',
            };
        default:
            return state
    }
}
